/* eslint-disable @nx/enforce-module-boundaries */
import { inject } from '@angular/core';
import { catchError, forkJoin, of } from 'rxjs';
import { NavigationService } from './core/navigation/navigation.service';
// import { MessagesService } from './layout/common/messages/messages.service';
import { NotificationsService } from './layout/common/notifications/notifications.service';
// import { QuickChatService } from './layout/common/quick-chat/quick-chat.service';

import { CfgService } from '@hmax-order/frontend/cfg';
import { CompanyHeaderService } from '@hmax-order/frontend/company';

/**
 * Dados carregados antes de a navegação concluir.
 *
 * **Nunca espere um `apiResource` aqui.** Recurso carrega por efeito, e efeito só
 * dá flush depois do bootstrap — que espera esta navegação. Esperar por um trava
 * o app no splash sem emitir uma única requisição.
 *
 * `cfg` e `company-header` continuam sendo disparados, mas **sem bloquear**: os
 * componentes leem os signals e atualizam quando o dado chega, que é o modelo do
 * recurso. Só entram no `forkJoin` fontes baseadas em `HttpClient` direto.
 */
export const initialDataResolver = () => {
  //   const messagesService = inject(MessagesService);
  const navigationService = inject(NavigationService);
  const notificationsService = inject(NotificationsService);
  //   const quickChatService = inject(QuickChatService);
  // const shortcutsService = inject(ShortcutsService);

  // Instanciar já dispara o carregamento dos recursos, sem esperar por eles.
  inject(CfgService);
  inject(CompanyHeaderService);

  // catchError em cada fonte: uma falha parcial não deve cancelar a navegação
  // pós-login e deixar a tela de sign-in travada com spinner
  return forkJoin([
    navigationService.get().pipe(catchError(() => of(null))),
    notificationsService.getAll().pipe(catchError(() => of([]))),
  ]);
};
